module.exports = __webpack_public_path__ + "static/img/teacher.55149af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher.jpg
// module id = aEmP
// module chunks = 1